<mat-expansion-panel
  class="bg-transparent  select-none pr-0"
  [expanded]="hasChildActive()"
  #panel
  hideToggle
>
  <mat-expansion-panel-header
    class="px-2 mx-2"
    [class.active-panel]="rla.isActive"
    [matTooltipDisabled]="!layout.menuShrunk()"
    matTooltip="Dashboard"
    matTooltipPosition="right"
  >
    <mat-panel-title
      class="text-white flex justify-between mr-0"
      (click)="$event.stopPropagation()"
    >
      <a
        class="cursor-pointer flex-1 pl-2"
        #rla="routerLinkActive"
        routerLink="/dashboard"
        routerLinkActive
      >
        <mat-label class="text-white flex align-middle">
          <i
            class="text-white ml-2 mr-4 text-3xl"
            [ngClass]="rla.isActive ? 'icon-dashboard' : 'icon-dashboard-stroke'"
            matPrefix
          ></i>
          @if (!layout.menuShrunk()) {
            <span class="text-sm">
              Dashboard
            </span>
          }
        </mat-label>
      </a>
      @if (!layout.menuShrunk()) {
        <mat-icon
          class="chevron-icon mr-[3px]"
          (click)="panel.toggle()"
          [class.rotated]="panel.expanded"
        >
          expand_more
        </mat-icon>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div [hidden]="layout.menuShrunk()">
    <ul class="ml-11 mr-4 mb-2 pl-2 border-0 border-l border-white max-h-[180px] overflow-y-auto">
      @for (item of dashboards(); track item.id) {
        <li>
          <a
            class="link block p-2 text-white"
            [routerLink]="['dashboards', item.id]"
            routerLinkActive="active"
          >
            {{ item.name }}
          </a>
        </li>
      }
    </ul>
    <a
      class="ml-11 mr-4 pl-2 text-ui-green-light"
      [queryParams]="{ mode: 'edit' }"
      [showForClientAdmin]="true"
      avsRestrictedEl
      queryParamsHandling="merge"
      routerLink="/dashboards/new"
    >
      + Add New Dashboard
    </a>
  </div>
</mat-expansion-panel>
